import React from 'react';
import { MathUtils } from 'three';
import { useTexture } from '../../../hooks';
import Button from '../button';
import { getSpotType } from '../../../common/utils';
import { CustomObject } from '../../../types/data';

// import spotBtnTxt from '../../../assets/images/xr/icons/hotspot-v2.png';
// import spotActiveBtnTxt from '../../../assets/images/xr/icons/hotspot-active-v2.png';
// import groundSpotBtnTxt from '../../../assets/images/xr/icons/ground-v2.png';
import helicopterSpotBtnTxt from '../../../assets/images/xr/icons/helicopter-v2.png';

import spotBtnTxt from '../../../assets/images/xr/icons/hotspot.png';
import spotActiveBtnTxt from '../../../assets/images/xr/icons/hotspot-active.png';
import groundSpotBtnTxt from '../../../assets/images/xr/icons/ground.png';
import CustomSpotItem from './CustomSpotItem';

const { degToRad } = MathUtils;

type SpotListProps = {
  data: any[];
  prevSpace: CustomObject;
  onSelect: (spot: any) => void;
};

const SpotList = ({ data = [], prevSpace, onSelect }: SpotListProps) => {
  const { texture: btnSpotTxt } = useTexture(spotBtnTxt);
  const { texture: btnSpotActiveTxt } = useTexture(spotActiveBtnTxt);

  const { texture: btnGroundSpotTxt } = useTexture(groundSpotBtnTxt);
  const { texture: btnHelicopterSpotTxt } = useTexture(helicopterSpotBtnTxt);

  const spotTextures = {
    default: btnSpotTxt,
    ground: btnGroundSpotTxt,
    helicopter: btnHelicopterSpotTxt,
  };

  return (
    <group name="spot-list">
      {data.map((spot: any) => {
        const spotType = getSpotType(spot.custom_image);
        const isPrevSpaceSpot = prevSpace.id === spot.to_point.id;

        const isDefault = spotType === 'default';
        // const rotation: ReactThreeFiber.Euler = [isDefault ? degToRad(45) : 0, 0, 0];
        if(spot.icon_url){
          return <CustomSpotItem spot={spot} onSelect={onSelect}/>
        }
        return (
          <group key={spot.id} rotation={[degToRad(-spot.atv), degToRad(-spot.ath), 0, 'YXZ']}>
            <Button
              position={[0, 0, -1.5]}
              defaultState={{
                main: {
                  size: (0.22 * spot.spot_size_percentage/100),
                  material: {
                    transparent: true,
                    map: isDefault && isPrevSpaceSpot ? btnSpotActiveTxt : spotTextures[spotType],
                    color: spot.color || "#ffffff"
                  },
                },
              }}
              onClick={() => onSelect(spot)}
            />
          </group>
        );
      })}
    </group>
  );
};

export default SpotList;
